import api from '../../../App/socket';

export const getLeadProfileWithNotes = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            attributes: ['notes.note', 'notes.created_date', 'notes.deleted_date', 'notes.deleted_by'],
            where: {
                _id,
            },
            include: {
                model: 'User',
                path: 'notes.note_by',
                attributes: ['person.first_name', 'person.last_name'],
            },
            orderBy: {
                'notes.created_date': -1,
            },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfileDisposition = (ref_lead) => (
    api.send({
        api: 'db',
        model: 'Lead_disposition',
        action: 'Read',
        options: {
            attributes: ['disposition', 'created_date', 'is_chat_bot'],
            where: {
                ref_lead,
            },
            order: {
                created_date: -1,
            },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfileConversation = (ref_lead) => (
    api.send({
        api: 'db',
        model: 'Lead_conversation',
        action: 'Read',
        options: {
            attributes: 'all',
            where: {
                ref_lead,
            },
            order: {
                created_date: -1,
            },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfileHistory = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            attributes: [
                'history.action',
                'history.created_date',
                'history.created_by',
            ],
            where: {
                _id,
            },
            include: [
                {
                    model: 'User',
                    path: 'history.created_by',
                    attributes: ['person.first_name', 'person.last_name'],
                },
                {
                    model: 'Bike_lead',
                    path: 'ref_bike_lead',
                    attributes: [
                        'history.action',
                        'history.created_date',
                        'history.created_by',
                    ],
                    include: {
                        model: 'User',
                        path: 'history.created_by',
                        attributes: ['person.first_name', 'person.last_name'],
                    },
                },
            ],
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfileWithRefs = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            where: {
                _id,
            },
            include: [
                {
                    model: 'Bike_lead',
                    attributes: 'all',
                    path: 'ref_bike_lead',
                    include: [
                        { model: 'Bike_model', attributes: 'all' },
                        { model: 'Bike_brand', attributes: 'all' },
                        { model: 'Bike_variant', attributes: 'all' },
                    ],
                },
            ],
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfileWithStatus = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            where: {
                _id,
            },
            include: {
                model: 'Lead_status',
                path: 'ref_lead_status',
                attributes: ['name'],
            },
        },
    })
        .then((response) => response)
        .catch((error) => error)
);

export const getLeadProfileWithApprovals = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            attributes: ['approval.price.requires_approval', 'approval.price.value',
                'approval.blemish_report.requires_approval', 'approval.blemish_report.value',
                'approval.hpi_check.requires_approval', 'approval.hpi_check.value',
                'approval.transport_date.requires_approval', 'approval.transport_date.value'],
            where: {
                _id,
            },
            include: [
                {
                    model: 'Lead_blemish_report',
                    path: 'lead_blemish_report',
                    attributes: ['ref_lead_blemish_report_status'],
                },
            ],
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadProfile = (_id) => api.send({
    api: 'db',
    model: 'Lead',
    action: 'Read',
    options: {
        limit: 1,
        attributes: 'all',
        where: {
            _id,
        },
        include:
                [
                    {
                        model: 'Lead_blemish_report',
                        path: 'lead_blemish_report',
                        attributes: ['ref_lead_blemish_report_status', 'rag_rating'],
                    },
                    {
                        model: 'Lead_customer',
                        path: 'ref_lead_customer',
                        attributes: 'all',
                        include: {
                            model: 'County_list',
                            path: 'address.county',
                            attributes: 'all',
                        },
                    },
                    {
                        model: 'Lead_transport',
                        path: 'lead_transport',
                        attributes: 'all',
                    },
                    {
                        model: 'Bike_lead',
                        attributes: 'all',
                        path: 'ref_bike_lead',
                        include:
                            [
                                {
                                    model: 'Bike_model',
                                    attributes: 'all',
                                    include: {
                                        model: 'User',
                                        path: 'price_suggestions.created_by',
                                        attributes: ['person.first_name', 'person.last_name'],
                                    },
                                },
                                { model: 'Bike_brand', attributes: 'all' },
                                { model: 'Bike_variant', attributes: 'all' },
                                {
                                    model: 'Bike_lead_upgrades',
                                    path: 'upgrades.ref_bike_lead_upgrades',
                                    attributes: 'all',
                                },
                            ],
                    },
                    {
                        model: 'User',
                        path: 'valuations.valuation_by',
                        attributes: ['person.first_name', 'person.last_name'],
                    },
                    {
                        model: 'Lead_status',
                        path: 'ref_lead_status',
                        attributes: ['name'],
                    },
                    {
                        model: 'Lead_source',
                        path: 'ref_lead_source',
                        attributes: ['abbr', 'name'],
                    },
                    {
                        model: 'User',
                        path: 'notes.note_by',
                        attributes: ['person.first_name', 'person.last_name'],
                    },
                    {
                        model: 'User',
                        path: 'ref_assigned_to',
                        attributes: ['person.first_name', 'person.last_name', 'person.photos.small'],
                    },
                    {
                        model: 'User',
                        path: 'ref_delivery_requested_assigned_to',
                        attributes: ['person.first_name', 'person.last_name', 'person.photos.small'],
                    },
                    {
                        model: 'User',
                        path: 'created_by',
                        attributes: ['person.first_name', 'person.last_name'],
                    },
                    {
                        model: 'Lead_affiliate',
                        path: 'marketing.ref_lead_affiliate',
                        attributes: ['name', 'abbr'],
                    },
                    {
                        model: 'Bike_inventory',
                        path: 'part_ex.ref_bike_inventory',
                        attributes: ['ref_bike_brand', 'ref_bike_model', 'superbike_factory_url', 'price.retail_price', 'inventory_status', 'vrm'],
                        include: [
                            {
                                model: 'Bike_brand',
                                path: 'ref_bike_brand',
                                attributes: ['name'],
                            },
                            {
                                model: 'Bike_model',
                                path: 'ref_bike_model',
                                attributes: ['name'],
                            },

                        ],
                    },
                    {
                        model: 'Lead_affiliate',
                        path: 'ref_lead_affiliate',
                        attributes: ['name', 'abbr'],
                    },
                ],
    },
}).then((response) => response).catch((error) => error);

export const getLeadProfileVariant = (model_id, variant_id, year) => (
    api.send({
        api: 'module',
        module: 'PlatformManagement',
        classMethod: 'GetBikeVariantsByModelIdAndCalcData',
        options: {
            where: {
                model_id,
                year,
                variant_id,
            },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadCustomer = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead_customer',
        action: 'Read',
        options: {
            limit: 1,
            include: {
                path: 'address.county',
                model: 'County_list',
                attributes: 'all',
            },
            attributes: [
                'full_name',
                'address.city',
                'preferred_contact_time',
                'preferred_contact_method',
                'address.county',
                'address.country',
                'address.street',
                'address.post_code',
                'phone',
                'email',
            ],
            where: { _id },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadAgent = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            include: {
                path: 'ref_assigned_to',
                model: 'User',
                attributes: ['person.first_name', 'person.last_name'],
            },
            attributes: ['ref_assigned_to'],
            where: { _id },
        },
    }).then((response) => response).catch((error) => error)
);

export const getLeadDeliveryRequestedAgent = (_id) => (
    api.send({
        api: 'db',
        model: 'Lead',
        action: 'Read',
        options: {
            limit: 1,
            include: {
                path: 'ref_delivery_requested_assigned_to',
                model: 'User',
                attributes: ['person.first_name', 'person.last_name'],
            },
            attributes: ['ref_delivery_requested_assigned_to'],
            where: { _id },
        },
    }).then((response) => response).catch((error) => error)
);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/get_lead_profile_request.js